import MerchantHelpSupportDesktop from './MerchantHelpSupportDesktop'
import MerchantHelpSupportMobile from './MerchantHelpSupportMobile'

export default function MerchantHelpSupportPage() {
  return (
    <>
      <MerchantHelpSupportMobile />
      <MerchantHelpSupportDesktop />
    </>
  )
}
